import {
  getSnowflakeValueFromRule,
  parseRules,
} from '@/pages/Screener/functions';

export const parseSnowflakePointsFromRules = (
  rules: string | undefined | null
) => {
  const parsedRules = parseRules(rules || '');
  const {
    valueScore: value,
    futurePerformanceScore: future,
    pastPerformanceScore: past,
    healthScore: health,
    dividendScore: dividends,
  } = getSnowflakeValueFromRule(parsedRules);
  const snowflakeScore = [
    value + 1,
    future + 1,
    past + 1,
    health + 1,
    dividends + 1,
  ];

  return snowflakeScore as [number, number, number, number, number];
};
